<template>

  <div  class="scheduler-wrapper">

	<div ref="cornerRef">	<Corner :printProject="printProject"
            :configs="props.configs" :projectFilter="projectFilter" @setProjectFilter="handleSetProjectFilter" />
    </div>
    <div ref="sidebarRef" :style="{height: printProject ? 'fit-content' : 'auto'}" :class="{printview: printProject}" class="sidebar" id="sidebar"  @scroll="syncScroll('left')">
		<ProjectHeader
		    v-for="(p, i) in displayProjects"
		    :project="p"
	         :isprintView="printProject || false"			
			:users="props.users"
			:bookings="displayBookings"
			:isopen="view.isOpenProject(p.id)"
			:resourceFilter="resourceFilter[p.id]"
			@updateResourceFilter="handleUpdateResourceFilter"
			@update="updateProjectOpenstates" 
			@print-view="handlePrintAction"
		  />
	</div>
    <div ref="timesheetRef" class="main-scroll-area" id="main-scroll-area"  @scroll="syncScroll('right')">
      <Timeaxis :key="`${startDate.getTime()}-${endDate.getTime()}`" :printProject="printProject" :startDate="startDate" :endDate="endDate" @deselect="closeSelection" :bookings="displayBookings"/>
	  <div class="timesheet" id="timesheet">
	    <ProjectTimesheet
      :key="`${p.id}-${startDate.getTime()}-${endDate.getTime()}-${projectTimesheetRefreshKey}`"
		  :startDate="startDate"
		  :endDate="endDate"
	      v-for="p in displayProjects"
	      :project="p"
	      :isprintView="(printProject && printProject.id === p.id) || false"
	      :projects="props.projects"
	      :users="props.users"
	      :bookings="displayBookings"
	      :isopen="view.isOpenProject(p.id)"
	      :resourceFilter="resourceFilter[p.id]"
	      :configs="props.configs"
	      @bookingDone="handleBookingDone"
	      @projectChangeDone="projectChangeDone"
	      @cancel="handleCancel"
	      @deselect="closeSelection"
	    />
	    <HighlightDays :startDate="startDate" :endDate="endDate" :isprintView="printProject !== null" :configs="props.configs" />
	    <div v-if="!printProject" id="today-line" class="today-line"> </div>
	    <div v-if="!printProject" id="selection-layer" class="selection-layer"></div>
	  </div>
    </div>
	
	<Callout id="projecttimePopup" :target="popupTarget" :show="showPopup" @close="closePopup" >

	  <!-- Context menu: only for bookings -->
	  <div v-if="popupMode === 'context'" style="min-width: 200px;" class="flex flex-col gap-2">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; padding: 0 2px;">Buchung ändern</p>
	    <button class="w-full text-left px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'datechange'">Zeitraum ändern</button>
	    <button class="w-full text-left px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'moveproject'">In anderes Projekt verschieben</button>
	    <button class="w-full text-left px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="handleDeleteFromContext">Buchung löschen</button>
	  </div>

	  <!-- Date change popup: projects and bookings -->
	  <div v-if="popupMode === 'datechange'">
	    <p>{{popupType === 0 ? "Projektzeitraum" : "Buchungszeitraum"}} ändern</p>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="entityStartDate = shiftDate(entityStartDate, -1)" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Start" :modelValue="entityStartDate" @datechange="handleStartDateChange" />
	      <button @click="entityStartDate = shiftDate(entityStartDate, 1)" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="entityEndDate = shiftDate(entityEndDate, -1)" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Ende" :modelValue="entityEndDate" @datechange="handleEndDateChange" />
	      <button @click="entityEndDate = shiftDate(entityEndDate, 1)" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleDateChangeApply()"
	    >
	      <span>Anwenden</span>
	    </button>
	  </div>

	  <!-- Move project popup: bookings only -->
	  <div v-if="popupMode === 'moveproject'">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">In Projekt verschieben</p>
	    <div style="max-height: 220px; overflow-y: auto;">
	      <div v-for="p in popupProjects" :key="p.id"
	        :style="{
	          display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0',
	          cursor: p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id) ? 'pointer' : 'not-allowed',
	          opacity: p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id) ? '1' : '0.35'
	        }"
	        @click="(p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id)) && (selectedPopupProjectId = p.id)"
	      >
	        <input type="radio" :checked="selectedPopupProjectId === p.id"
	          :disabled="p.id !== popupProjects[0]?.id && !compatibleProjectIds.has(p.id)"
	          style="cursor:inherit;" />
	        <span :style="{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: p.color, flexShrink: 0, display: 'inline-block' }"></span>
	        <span style="font-size: 13px;">{{ p.id === popupProjects[0]?.id ? p.name + ' (belassen)' : p.name }}</span>
	      </div>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleMoveApply()"
	    >
	      <span>Verschieben</span>
	    </button>
	  </div>

	</Callout>
	
	<BookingSelectionPopup ref="selectionPopupRef"
	                      :projects="displayProjects"
						  :users="props.users"
						  :bookings="displayBookings"
						  :xScale="xScaleRef"
						  :days="daysRef"
						  @bookingDone="handleBookingDone"
						  @dateupdate="handleDateUpdate" />
						  
    <ConfirmModal ref="confirmModal" :message="modalMessage" :colsitems="modalColsItems" :items="modalItems" />

	<div v-if="printProject" class="print-footer">
        <div class="footer-content">
            <button type="button" class="footer-btn" @click="handleDownloadPdf(printProject)">
                <Printer :size="24" />
                <span>PDF Drucken</span>
            </button>
            <button type="button" class="footer-btn secondary" @click="handleRestorePlanner">
                <ArrowBigLeft :size="24" />
                <span>Zurück</span>
            </button>
        </div>
    </div>
  </div>

  <Transition name="undo-btn">
    <button
      v-if="undoStack.length > 0"
      @click="performUndo"
      class="fixed bottom-6 right-6 z-[9998] w-12 h-12 rounded-full bg-timin text-black flex items-center justify-center shadow-lg hover:brightness-90 active:scale-95 transition-transform"
      title="Rückgängig (Strg+Z)"
    >
      <Undo2 :size="20" />
    </button>
  </Transition>

  <div v-if="isLoading" class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/10 pointer-events-auto">
    <div class="animate-spin rounded-full h-10 w-10 border-4 border-white/40 border-t-timin"></div>
  </div>

  <div v-if="isGenerating" class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <Card class="w-[300px] p-6 text-center">
      <div class="mb-4 font-bold text-sm">PDF wird generiert...</div>
      
      <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div 
          class="bg-timin h-full transition-all duration-300 ease-out"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
      
      <div class="mt-2 text-xs text-muted-foreground">{{ Math.round(progress) }}%</div>
    </Card>
  </div>

</template>

<script setup lang="ts">
import {onMounted, computed, ref, provide, watch, nextTick } from 'vue';
import {useViewStore} from "@/stores/viewStore"
import * as d3 from 'd3';
import {formatDateYYYYMMDD, utcToLocal, nextDay, positionTodayLine, cleanx, stopAutoScroll, handleAutoScroll, getWeekBounds, generateTiledPdf, sortProjects, removeSelections, computeResourceFilter, scrollToToday, sendRequest, prepProject, prepBooking, dayMs, getWidthPerDay, getRowHeight, box2int, germanToISO, germanToISODate, setDim, getProjectFromRow, getXDateUTC, formatDateDDMMYYYY} from "./planner.js";
import BookingSelectionPopup from './BookingSelectionPopup.vue'
import Corner from './Corner.vue'
import Timeaxis from './Timeaxis.vue'
import ProjectHeader from './ProjectHeader.vue'
import ProjectTimesheet from './ProjectTimesheet.vue'
import HighlightDays from './HighlightDays.vue'
import ConfirmModal from './ConfirmModal.vue'
import DateInput from "./DateInput.vue"
import Callout from './Callout.vue'
import { Card } from "@/components/ui/card"
import { Printer, ArrowBigLeft, Undo2 } from "lucide-vue-next"
import { colscollisions } from '../timintables/colscollisions'
import { POPUP_BUS } from './popupBus'

const props = defineProps({
  projects: { type: Array, required: true },
  bookings: { type: Array, required: true },
  users: { type: Array, required: true },
  configs: { type: Array, required: true },
});

const cornerRef = ref(null);
const sidebarRef = ref(null);
const timesheetRef = ref(null)
const projectTimesheetRefreshKey = ref(0)

const isGenerating = ref(false);
const progress = ref(0); // 0 to 100

const handleDownloadPdf = async (project) => {
  if (!timesheetRef.value) return;
  
  isGenerating.value = true;
  progress.value = 0; // Reset progress
  
  try {
    const { default: html2canvas } = await import('html2canvas');
    const { jsPDF } = await import('jspdf');

    // Pass a callback to update progress
    await generateTiledPdf(project, 
      timesheetRef.value, 
      cornerRef.value, 
      sidebarRef.value, 
      html2canvas, 
      jsPDF,
      (p) => { progress.value = p; } // New callback argument
    );
    
  } catch (error) {
    console.error("PDF Generation failed:", error);
  } finally {
    // Small delay so the user sees "100%" before it vanishes
    setTimeout(() => {
      isGenerating.value = false;
      progress.value = 0;
    }, 500);
  }
};

const view = useViewStore();
view.setCountActiveUsers(props.users.filter(u => u.role_id > 0 && u.is_active === 1).length)

const selectionPopupRef = ref(null)
const confirmModal = ref(null)
const modalColsItems = ref(null)
const modalItems = ref([])
const modalMessage = ref("Bestätigen")
const projectFilter = ref({all: view.showAllBookings(), active: view.showActiveProjects(), planned: view.showPlannedProjects()})
const resourceFilter = ref(computeResourceFilter(view, props.projects, props.users, props.bookings));
const xScaleRef = ref(null);
const daysRef = ref([]);

const isLoading = ref(false)

const printProject = ref(null)
const printStart = ref(null)
const printEnd = ref(null)

const startDateStr = props.configs.find(c => c.name === "startdate").value;
const endDateStr = props.configs.find(c => c.name === "enddate").value;

const initialStartDate = new Date(startDateStr + "T00:00:00");
const initialEndDate = new Date(endDateStr   + "T00:00:00");

const startDate = ref<Date>(initialStartDate)
const endDate   = ref<Date>(initialEndDate)

let widthPerDay= getWidthPerDay(printProject.value !== null)
const totalDays = (endDate.value.getTime() - startDate.value.getTime()) / dayMs;

const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

xScaleRef.value = x;

const dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

watch(
  [printStart, printEnd],
  async ([ps, pe]) => {
	console.log("watch printStart, printEnd=" + ps + " " + pe)
    if (ps && pe) {
      // If ps is already a Date object, don't append the time string
      startDate.value = ps instanceof Date ? ps : new Date(germanToISO(ps) + "T00:00:00");
      endDate.value   = pe instanceof Date ? pe : new Date(germanToISO(pe) + "T00:00:00");
    } else {
      startDate.value = initialStartDate;
      endDate.value   = initialEndDate;
    }
	console.log("watch new values=" + startDate.value + " " + endDate.value)

    await nextTick();
    renderTimesheet();
  }
);

const entityStartDate = ref(formatDateDDMMYYYY(new Date()));
const entityEndDate = ref(formatDateDDMMYYYY(new Date()));

const uid = ref(document.getElementById('app').dataset.uid)
console.log("uid=" + uid.value)
const localProjects = ref<any[]>([...props.projects]);
const displayProjects = computed(() => [...sortProjects(localProjects.value.filter(p => projectFilter.value.active  && p.status === 0 && (printProject.value ? printProject.value.id === p.id : true))).map(p => prepProject(p)),
                                        ...sortProjects(localProjects.value.filter(p => projectFilter.value.planned && p.status === 2)).map(p => prepProject(p))]);

const localBookings = ref<any[]>([...props.bookings]);

const undoStack = ref<any[]>([])
let isUndoing = false

function pushUndo(action: any) {
  if (isUndoing) return
  undoStack.value.push(action)
  if (undoStack.value.length > 20) undoStack.value.shift()
}
const displayBookings = computed(() =>
  localBookings.value
    .filter(b => projectFilter.value.all || b.user_id.toString() === uid.value.toString())
    .map(b => prepBooking(b))
);


const emit = defineEmits(['update:bookings', 'update:projects', 'reload'])

let leftLastTop = 0;
let leftLastLeft = 0;

let rightLastTop = 0;
let rightLastLeft = 0;


function syncScroll(source) {
  const el = source === 'left' ? sidebarRef.value : timesheetRef.value;
  const other = source === 'left' ? timesheetRef.value : sidebarRef.value;

  let dx, dy;

  if (source === 'left') {
    dx = Math.abs(el.scrollLeft - leftLastLeft);
    dy = Math.abs(el.scrollTop - leftLastTop);

    leftLastLeft = el.scrollLeft;
    leftLastTop = el.scrollTop;
  } else {
    dx = Math.abs(el.scrollLeft - rightLastLeft);
    dy = Math.abs(el.scrollTop - rightLastTop);

    rightLastLeft = el.scrollLeft;
    rightLastTop = el.scrollTop;
  }

  other.scrollTop = el.scrollTop;
}

function handleSetProjectFilter(all, active, planned) {
  view.setProjectFilter(all, active, planned); 
}

function updateProjectOpenstates(pid) {
	view.toggleProject(pid);
}

function handleUpdateResourceFilter(pid, rf) {
  console.log("handleUpdateResourceFilter pid=" + pid + " resourceFilter=" + JSON.stringify(rf));
  resourceFilter.value[pid].selection = rf.selection;
  resourceFilter.value[pid].individual = rf.individual; 
  view.setResourceFilter(pid, rf.selection, rf.individual)
}


const showPopup = ref(false)
const popupTarget = ref<HTMLElement | null>(null)
const popupType = ref(null);
const popupMode = ref<string | null>(null);
const popupEntity = ref(null);
const selectedPopupProjectId = ref<number | null>(null);

function openPopupAt(el: HTMLElement, entity) {
  console.log("openPopupAt id=" + el.id + "=" + JSON.stringify(entity))
  popupTarget.value = el
  showPopup.value = true
  popupType.value = entity.isproject ? 0 : 1;
  popupMode.value = entity.isproject ? 'datechange' : 'context';
  entityStartDate.value = formatDateDDMMYYYY(entity.start);
  entityEndDate.value = formatDateDDMMYYYY(entity.end);
  popupEntity.value = entity;
  if (!entity.isproject) {
    const booking = localBookings.value.find((b: any) => b.id === entity.id)
    selectedPopupProjectId.value = booking ? booking.project_id : null
  }
}

function closePopup() {
  showPopup.value = false
  closeSelection();		
}

// Provide the API for children
provide(POPUP_BUS, { openPopupAt, closePopup })

function handleStartDateChange(d) {
  entityStartDate.value = d;
}

function handleEndDateChange(d) {
  entityEndDate.value = d;
}

const popupProjects = computed(() => {
  if (!popupEntity.value || popupEntity.value.isproject) return []
  const booking = localBookings.value.find((b: any) => b.id === popupEntity.value.id)
  const currentPid = booking ? booking.project_id : null
  const currentProject = displayProjects.value.find((p: any) => p.id === currentPid)
  const others = displayProjects.value.filter((p: any) => p.id !== currentPid && p.id !== 0 && !p.isspacer)
  return currentProject ? [currentProject, ...others] : others
})

const compatibleProjectIds = computed(() => {
  if (!entityStartDate.value || !entityEndDate.value) return new Set<number>()
  const bStart = germanToISODate(entityStartDate.value)
  const bEnd = germanToISODate(entityEndDate.value)
  if (isNaN(bStart.getTime()) || isNaN(bEnd.getTime())) return new Set<number>()
  return new Set<number>(
    displayProjects.value
      .filter((p: any) => p.id !== 0 && !p.isspacer && bStart <= p.end && bEnd >= p.start)
      .map((p: any) => p.id)
  )
})

watch(compatibleProjectIds, (compatible) => {
  if (selectedPopupProjectId.value !== null && !compatible.has(selectedPopupProjectId.value)) {
    selectedPopupProjectId.value = popupProjects.value[0]?.id ?? null
  }
})

function shiftDate(dateStr: string, days: number): string {
  const d = germanToISODate(dateStr)
  if (isNaN(d.getTime())) return dateStr
  d.setDate(d.getDate() + days)
  return formatDateDDMMYYYY(d)
}

function handleDateChangeApply() {
  const isProject = popupEntity.value.isproject;
  const pid = isProject ? popupEntity.value.id : selectedPopupProjectId.value;
  const params = {
    isproject: isProject,
    id: popupEntity.value.id,
    booking_action: pid,
    selected_pid: pid,
    selected_bid: isProject ? null : popupEntity.value.id,
    firstDay: entityStartDate.value,
    lastDay: entityEndDate.value,
    selectedResources: [popupEntity.value.uid],
    shift: false,
    changedir: false,
  };
  closePopup();
  isLoading.value = true;
  setTimeout(() => {
    try {
      if (isProject) {
        projectChangeDone(params);
      } else {
        handleBookingDone(params, null);
      }
    } finally {
      isLoading.value = false;
    }
  }, 10);
}

function handleMoveApply() {
  const bookingIdForMove = popupEntity.value.id;
  const booking = localBookings.value.find((b: any) => b.id === popupEntity.value.id);
  const targetProjectId = (selectedPopupProjectId.value !== null && selectedPopupProjectId.value !== booking?.project_id)
    ? selectedPopupProjectId.value
    : null;
  closePopup();
  if (targetProjectId !== null) {
    isLoading.value = true;
    setTimeout(() => {
      try {
        handleMoveToProject(bookingIdForMove, targetProjectId);
      } finally {
        isLoading.value = false;
      }
    }, 10);
  }
}

function handleDeleteFromContext() {
  if (!popupEntity.value) return;
  const bookingId = popupEntity.value.id;
  const booking = localBookings.value.find((b: any) => b.id === bookingId);
  if (!booking) return;
  pushUndo({ type: 'deletedBooking', booking: { ...booking } });
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId);
  closePopup();
  isLoading.value = true;
  setTimeout(() => {
    sendRequest(`/bookings/${bookingId}`, {}, function() {
      isLoading.value = false;
      updatePlanner();
    }, function(response) {
      undoStack.value.pop();
      localBookings.value.push(booking);
      isLoading.value = false;
      alert(response.error || 'Fehler beim Löschen');
      updatePlanner();
    }, 'DELETE');
  }, 10);
}

function updatePlanner() {
	closeSelection();	
	//emit('reload');
}

function handleBookingDone(params, afterSuccess: (() => void) | null = null) {
  if (params.selected_bid) {
    const old = localBookings.value.find((b: any) => b.id === params.selected_bid)
    if (old) pushUndo({ type: 'booking', params: { ...params, firstDay: old.start, lastDay: old.end } })
  }
  const previousIds = new Set(localBookings.value.map((b: any) => b.id))
  sendRequest('/update_bookings', params, function(bookings) {
    localBookings.value = bookings

    localProjects.value = localProjects.value.map((p: any) => {

      if (params["selected_pid"] === p.id && params["newpstart"]) {
        console.log("handleBookingDone p=" + JSON.stringify(p) + " newpstart=" + params["newpstart"] + " newpend=" + params["newpend"])
        return {
          ...p,
          start: formatDateYYYYMMDD(utcToLocal(params["newpstart"])),
          end: formatDateYYYYMMDD(utcToLocal(params["newpend"]))
        }
      }

      return p
    })
    projectTimesheetRefreshKey.value++

    if (!params.selected_bid && params.booking_action !== -1) {
      const newIds = bookings.filter((b: any) => !previousIds.has(b.id)).map((b: any) => b.id)
      if (newIds.length > 0) pushUndo({ type: 'newBooking', bookingIds: newIds })
    }
    if (afterSuccess) afterSuccess();
    else updatePlanner();
  }, function(response) {
    alert(response.error);
    updatePlanner();
  });
}

function handleMoveToProject(bookingId: number, projectId: number) {
  const old = localBookings.value.find((b: any) => b.id === bookingId)
  if (old) pushUndo({ type: 'moveToProject', bookingId, oldProjectId: old.project_id })
  const userId = old?.user_id
  const oldProjectId = old?.project_id
  sendRequest(`/bookings/${bookingId}`, { booking: { project_id: projectId } }, function(booking) {
    const idx = localBookings.value.findIndex((b: any) => b.id === bookingId);
    if (idx !== -1) localBookings.value.splice(idx, 1, booking);
    if (userId) {
      if (resourceFilter.value[projectId] && !resourceFilter.value[projectId].hasBookings.includes(userId)) {
        resourceFilter.value[projectId].hasBookings.push(userId);
      }
      if (oldProjectId && resourceFilter.value[oldProjectId]) {
        const stillHasBookings = localBookings.value.some((b: any) => b.user_id === userId && b.project_id === oldProjectId);
        if (!stillHasBookings) {
          resourceFilter.value[oldProjectId].hasBookings = resourceFilter.value[oldProjectId].hasBookings.filter((id: number) => id !== userId);
        }
      }
    }
    updatePlanner();
  }, function(response) {
    alert(response.error);
  }, 'PATCH');
}

function projectChangeDone(params) {
	const old = localProjects.value.find((p: any) => p.id === params.selected_pid)
	if (old) pushUndo({ type: 'projectChange', params: { ...params, firstDay: old.start, lastDay: old.end } })
	sendRequest('/change_project_date', params, function(response) {
		localProjects.value = response["projects"]
		let affected_bookings = response["affected_bookings"]
		modalMessage.value = "Folgende Buchungen sind betroffen"
		modalColsItems.value = colscollisions
		modalItems.value = affected_bookings
		console.log("affected_bookings=" + JSON.stringify(affected_bookings))
		if (affected_bookings.length > 0) {
			confirmModal.value.open();			
		}
    updatePlanner()
	}, function(response) {
		alert(response['error']);
    updatePlanner()
	});
}

function performUndo() {
  const action = undoStack.value.pop()
  if (!action) return
  isUndoing = true
  if (action.type === 'booking') {
    sendRequest('/update_bookings', action.params, function(bookings) {
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      alert(response.error)
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'moveToProject') {
    sendRequest(`/bookings/${action.bookingId}`, { booking: { project_id: action.oldProjectId } }, function(booking) {
      const idx = localBookings.value.findIndex((b: any) => b.id === booking.id)
      if (idx !== -1) localBookings.value[idx] = booking
      updatePlanner()
      isUndoing = false
    }, function(response) {
      alert(response.error)
      isUndoing = false
    }, 'PATCH')
  } else if (action.type === 'newBooking') {
    const token = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
    action.bookingIds.forEach((id: number) => {
      const xhr = new XMLHttpRequest()
      xhr.open('DELETE', `/bookings/${id}`, false)
      xhr.setRequestHeader('X-CSRF-Token', token)
      xhr.send()
    })
    sendRequest('/bookings.json', {}, function(bookings) {
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function() { isUndoing = false }, 'GET')
  } else if (action.type === 'projectChange') {
    sendRequest('/change_project_date', action.params, function(response) {
      localProjects.value = response["projects"]
      updatePlanner()
      isUndoing = false
    }, function(response) {
      alert(response['error'])
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'deletedBooking') {
    const b = action.booking
    const params = {
      isproject: false,
      booking_action: b.project_id,
      selected_pid: b.project_id,
      selected_bid: null,
      firstDay: b.start,
      lastDay: b.end,
      selectedResources: [b.user_id],
      shift: false,
      changedir: false,
    }
    sendRequest('/update_bookings', params, function(bookings) {
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      alert(response.error)
      isUndoing = false
    })
  }
}

function deleteSelectedBooking() {
  const selected = (document.querySelector('.task.highlight-bar') || document.querySelector('.task.editable')) as HTMLElement | null
  if (!selected) return

  const parts = selected.id.split('-')
  if (parts.length < 3) return  // Projektzeile, keine Buchung

  const bookingId = parseInt(parts[parts.length - 1])
  if (isNaN(bookingId)) return

  const booking = localBookings.value.find((b: any) => b.id === bookingId)
  if (!booking) return

  pushUndo({ type: 'deletedBooking', booking: { ...booking } })
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId)
  closePopup()

  sendRequest(`/bookings/${bookingId}`, {}, function() {
    updatePlanner()
  }, function(response) {
    undoStack.value.pop()
    localBookings.value.push(booking)
    alert(response.error || 'Fehler beim Löschen')
    updatePlanner()
  }, 'DELETE')
}

function handleDateUpdate(startdate, enddate) {
	console.log("handleDateUpdate startdate, enddate=" + startdate +  " " +  enddate);
	
	let startDate = germanToISODate(startdate);
	let endDate   = germanToISODate(enddate);
	 
	const rect = document.querySelector(".selection-rectangle") as HTMLElement | null;
	if (!rect) {
		return;
	}

	let newleft = parseFloat(rect.style.left);
	const x = xScaleRef.value;
	if (!x) return;
	let newWidth = cleanx(x, endDate) - cleanx(x, startDate) + getWidthPerDay(printProject.value !== null);
	setDim(rect, newleft, parseFloat(rect.style.top), newWidth, parseFloat(rect.style.height), dayWidth, getRowHeight(printProject.value !== null));
}

function handleCancel() {
   console.log("reload in D3Planner")
   emit('reload')
}

function closeSelection() {
  removeSelections()
  document.getElementById("timesheet").classList.remove("disable-selection");
  const selectionLayer = document.getElementById('selection-layer');
  if (!selectionLayer) {
	return
  }
  let sel = selectionLayer.querySelector('.selection-rectangle');
  if (sel) {
    sel.remove();
	selectionPopupRef.value?.handleSelectionClose();
  }		
}  

function renderTimesheet() {
	console.log("startDateStr=" + startDateStr)
	console.log("startDate=" + startDate.value)
	console.log("endDate=" + endDate.value)

	endDate.value = nextDay(endDate.value);

	let widthPerDay= getWidthPerDay(printProject.value !== null)
    const totalDays = (endDate.value.getTime() - startDate.value.getTime()) / dayMs;

    const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

    xScaleRef.value = x;

    let dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

	const timesheet = document.getElementById("timesheet");
	timesheet.style.width = `${totalDays * widthPerDay}px`;

	const sidebar = document.getElementById("sidebar");
	const mainScrollArea = document.getElementById("main-scroll-area");

    const days = d3.timeDay.range(startDate.value, endDate.value);
	daysRef.value = days;

	//console.log("holidays=" + JSON.stringify(holidays))


	const selectionLayer = document.getElementById('selection-layer');

	// add a vertical line for today's date'
	if (!printProject.value) {
	  positionTodayLine("today-line", x);
	}
	
	document.addEventListener("keydown", e => {
		if (e.code === "Escape") {
			closeSelection();
		}
		if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
			e.preventDefault()
			performUndo()
		}
		if (e.code === 'Backspace' && !(e.target as Element).closest('input, textarea, select, [contenteditable]')) {
			e.preventDefault()
			isLoading.value = true;
			setTimeout(() => {
				try {
					deleteSelectedBooking()
				} finally {
					isLoading.value = false;
				}
			}, 10);
		}
	})


  let longPressTimer: number
	let startX = 0
	let startY = 0
	const LONG_PRESS_THRESHOLD = 500 // ms
	const MOVE_THRESHOLD = 10 // pixels

	if (printProject.value) {
	  //no need to allow listeners
	  return;
	}
	timesheet.addEventListener("pointerdown", e => {
	  if ((e.target as Element).closest(".task") || (e.target as Element).closest(".selection-rectangle") || (e.target as Element).closest(".project-row")) return;

    window.__POINTER_DOWN__ = true;

	  document.querySelectorAll(".task.editable").forEach(t => t.classList.remove("editable"));

	  startX = e.clientX
	  startY = e.clientY
	  let moved = false
	  let longPressTriggered = false

	  console.log("pointerdown")
	  // Start long press timer
	  longPressTimer = window.setTimeout(() => {
	    longPressTriggered = true
	    closeSelection()
	    selectionPopupRef.value?.handleSelectionClose();
	    startSelectionRectangle(e)
	  }, LONG_PRESS_THRESHOLD)

	  const onPointerMove = (ev: PointerEvent) => {
	    const dx = ev.clientX - startX
	    const dy = ev.clientY - startY
	    if (Math.hypot(dx, dy) > MOVE_THRESHOLD) {
	      moved = true
	      clearTimeout(longPressTimer)
	      timesheet.removeEventListener("pointermove", onPointerMove)
	      timesheet.removeEventListener("pointerup", onPointerUp)
	    }
	  }

	  const onPointerUp = (ev: PointerEvent) => {
	    clearTimeout(longPressTimer)
	    timesheet.removeEventListener("pointermove", onPointerMove)
	    timesheet.removeEventListener("pointerup", onPointerUp)

      window.__POINTER_DOWN__ = false;

	    if (!longPressTriggered && !moved) {
	      // Short tap / click
	      closeSelection()
	      startSelectionRectangle(ev, true)
	    }
	    // else: either long press triggered or user dragged → do nothing
	  }

	  timesheet.addEventListener("pointermove", onPointerMove)
	  timesheet.addEventListener("pointerup", onPointerUp)
	})


	// Assume `closeSelection()` is your deselect callback
	function enableTouchDeselect(timesheetEl: HTMLElement) {
	  const onTouchStart = (e: TouchEvent) => {
	    // Only trigger if selection is active and user taps outside rectangle
	    const target = e.target as HTMLElement
	    if (!target.closest(".selection-rectangle")) {
	      closeSelection()
	      removeListeners()
	    }
	  }

	  const removeListeners = () => {
	    timesheetEl.removeEventListener("touchstart", onTouchStart)
	  }

	  timesheetEl.addEventListener("touchstart", onTouchStart)
	}

	// Usage: when selection is active on touch devices
	function onSelectionActivated() {
	  if ("ontouchstart" in window) {
	    enableTouchDeselect(timesheet)
	  }
	}

		
	timesheet.addEventListener('contextmenu', e => {
	  e.preventDefault(); // block long-press context menu
	});

	function startSelectionRectangle(e, immediate = false) {
	  //enableTouchDeselect(timesheet);
	  closePopup();
	  timesheet.classList.add("disable-selection");
	  const rect = document.createElement("div");
	  const openPopup = () => {
		  let b = box2int({x: rect.style.left,
			                 y: rect.style.top,
						           width: rect.style.width,
						          height: rect.style.height });
	    console.log("b=" + JSON.stringify(b));
		  selectionPopupRef.value?.handleSelectionComplete(b);
	  } 

	  rect.removeEventListener("click", openPopup);
	  rect.className = "selection-rectangle";
	  selectionLayer.appendChild(rect);

	  const containerRect = selectionLayer.getBoundingClientRect();
	  const startX = e.clientX - containerRect.left;
	  const startY = e.clientY - containerRect.top;
	  console.log("startX=" + startX + " startY=" + startY)

	  const rh = getRowHeight(printProject.value !== null)
	  setDim(rect, startX, startY, dayWidth, rh, dayWidth, rh);

	  if (immediate) {
		  let clickDate = getXDateUTC(x, startX);
		  console.log("immediate=" + immediate)
		  let p = getProjectFromRow(e, displayProjects.value);
		  if (!p || clickDate < p.start || clickDate > p.end) {
			  closeSelection();
			  return;
	  	}
		  openPopup();
		  return;		
	  }

	  const container = document.querySelector('.main-scroll-area');
	  
    let initialScroll = container.scrollLeft

	  const onMove = e2 => {
		  handleAutoScroll(e2);

		  const scrollDiff = container.scrollLeft - initialScroll;

	    const dx = e2.clientX - containerRect.left + scrollDiff;
	    const dy = e2.clientY - containerRect.top;

	    const left = Math.min(startX, dx);
	    const top = Math.min(startY, dy);
	    const width = Math.max(Math.abs(dx - startX), dayWidth);
	    const height = Math.max(Math.abs(dy - startY), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh)
	  }

	  const onUp = e2 => {
	    timesheet.removeEventListener("pointermove", onMove);
	    timesheet.removeEventListener("pointerup", onUp);
      window.__POINTER_DOWN__ = false;
	    snapSelectionRectangleToGrid(rect);
	    rect.addEventListener("click", openPopup);
	  };

	  timesheet.addEventListener("pointermove", onMove);
	  timesheet.addEventListener("pointerup", onUp);

	  function snapSelectionRectangleToGrid(rect) {
	    const left = parseFloat(rect.style.left);
	    const top = parseFloat(rect.style.top);
	    const width = Math.max(parseFloat(rect.style.width), dayWidth);
	    const height = Math.max(parseFloat(rect.style.height), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh);
	  	  
	    addResizeHandlesTo(rect);
	    openPopup();
	  }

	  function addResizeHandlesTo(rect) {
	    const positions = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];

	    for (const pos of positions) {
	      const handle = document.createElement("div");
	      handle.className = `resize-handle ${pos}`;
	      rect.appendChild(handle);

	      setupResizeHandle(handle, rect, pos);
	    }
      }

	  function setupResizeHandle(handle, rect, position) {
	    handle.addEventListener("pointerdown", e => {
	      e.stopPropagation();
	      e.preventDefault();

        selectionPopupRef.value?.handleSelectionClose();
        window.__POINTER_DOWN__ = true;
        
        let initialScroll = container.scrollLeft
	      const startX = e.clientX;
	      const startY = e.clientY;
	      const startLeft = parseFloat(rect.style.left);
	      const startTop = parseFloat(rect.style.top);
	      const startWidth = parseFloat(rect.style.width);
	      const startHeight = parseFloat(rect.style.height);

		    const onMove = e2 => {
		      handleAutoScroll(e2); 
			
			    const scrollDiff = container.scrollLeft - initialScroll;

          const dx = (e2.clientX - startX) + scrollDiff;
			    const dy = e2.clientY - startY;
			
			    let newLeft = startLeft;
			    let newTop = startTop;
			    let newWidth = startWidth;
			    let newHeight = startHeight;

			    if (position.includes("e")) {
				    newWidth = startWidth + dx;
			    }
			    if (position.includes("s")) {
				    newHeight = startHeight + dy;
		      }
			    if (position.includes("w")) {
				    newLeft = startLeft + dx;
				   newWidth = startWidth - dx;
			    }
			    if (position.includes("n")) {
				    newTop = startTop + dy;
				    newHeight = startHeight - dy;
			    }

			    // Snap to grid
			    newLeft = Math.round(newLeft / dayWidth) * dayWidth;
			    newTop = Math.round(newTop / rh) * rh;
			    newWidth = Math.round(newWidth / dayWidth) * dayWidth;
			    newHeight = Math.round(newHeight / rh) * rh;

			    newWidth = Math.max(dayWidth, newWidth);
			    newHeight = Math.max(rh, newHeight);

			    setDim(rect, newLeft, newTop, newWidth, newHeight, dayWidth, rh);
		    };

	      const onUp = () => {
	        document.removeEventListener("pointermove", onMove);
	        document.removeEventListener("pointerup", onUp);
	        snapSelectionRectangleToGrid(rect);
	      };

	      document.addEventListener("pointermove", onMove);
	      document.addEventListener("pointerup", onUp);
	    });
	  }
	}
	
	scrollToToday(x);
}


function handlePrintAction(project, start, end) {
   console.log("printview p=" + project.name + " start=" + start + " end=" + end)

   let bounds = getWeekBounds(start, end)

   printProject.value = project;
   //printStart.value = start;
   //printEnd.value = end;
   printStart.value = bounds["earliestMonday"];
   printEnd.value = bounds["latestSunday"];
}

function handleRestorePlanner() {
   printProject.value = null;
   printStart.value = null;
   printEnd.value = null;
}


onMounted(() => {

  window.__POINTER_DOWN__ = false;

  window.addEventListener("pointerdown", () => {
    window.__POINTER_DOWN__ = true;
  });

  window.addEventListener("pointerup", () => {
    window.__POINTER_DOWN__ = false;
  });

  window.addEventListener("pointercancel", () => {
    window.__POINTER_DOWN__ = false;
  });

  // iPad fallback (important!)
  window.addEventListener("touchend", () => {
    window.__POINTER_DOWN__ = false;
  });

  setInterval(() => {
    if (!window.__POINTER_DOWN__) {
      stopAutoScroll();
    }
  }, 50);

  renderTimesheet();
});
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: sans-serif;
}

.scheduler-wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  width: fit-content;
  height: 100vh;
  position: relative;
  overflow: visible;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  height: 96px;
}

#sidebar {
  grid-column: 1;
  grid-row: 2;
  overflow-y: auto;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  font-size: 12px;
  padding-bottom: 6px;
}

#sidebar.printview {
  background: white !important;
  border-top: 2px solid black;
}



.sidebar-group {
  font-weight: bold;
  background: #ddd;
  padding: 4px;
  border-bottom: 1px solid #bbb;
  cursor: pointer;
  user-select: none;
}

.sidebar-resource {
  padding-left: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-scroll-area {
  grid-column: 2;
  grid-row: 1 / span 2;
  overflow: auto;
  position: relative;
  background-color: white;
}

.main-scroll-area {
  scrollbar-width: auto;           /* "auto" | "thin" */
  scrollbar-color: #999 #e5e5e5;   /* thumb | track */
}

/* WebKit (Chrome, Edge, Safari) */
.main-scroll-area::-webkit-scrollbar {
  height: 66px;   /* horizontal scrollbar thickness only */
  width: auto;    /* vertical stays default */
}

.main-scroll-area::-webkit-scrollbar-track {
  background: #e5e5e5;
}

.main-scroll-area::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 8px;
  border: 3px solid #e5e5e5; /* optional padding effect */
}

.main-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #777;
}
.timesheet {
  position: relative;
  width: max-content;

  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

#today-button {
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.task.editable .resize-handle {
  display: block;
}

.resize-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px; /* bigger touch area */
  margin: 0 -10px; /* overlap into task */
  z-index: 2;
  background: transparent;
  cursor: ew-resize;
  display: none;
  touch-action: none; /* prevent unwanted pinch-zoom or pan */
}

.resize-handle::before {
  content: "";
  position: absolute;
  top: 25%;
  bottom: 25%;
  width: 4px;
  background-color: #666;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.resize-handle.left {
  left: -3px;
}

.resize-handle.right {
  right: -3px;
}

.task.editable .drag-handle {
  display: block;
}

.drag-handle {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background-color: #444;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  cursor: grab;
  z-index: 10;
  touch-action: none;
}

.drag-handle:active {
  cursor: grabbing;
}

.selection-layer {
  position: absolute;  /* or relative if it's already inside a positioned container */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: visible;
  z-index: 1000;  /* lower than .selection-rectangle (z: 5 or 10) */
  pointer-events: none; /* so other things like tasks remain clickable */

   -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: none;
}


.selection-rectangle {
  position: absolute;
  border: 2px dashed #007bff;
  background-color: rgba(0, 123, 255, 0.1);
  pointer-events: auto;
  z-index: 1000;
}

.selection-rectangle .resize-handle {
  position: absolute;
  width: 24px;
  height: 24px;
  background: red;
  border: 2px solid white;
  border-radius: 4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
  z-index: 1010;
  display: block;
  pointer-events: auto;
  box-sizing: border-box;
}

.timesheet.disable-selection {
  touch-action: none;
  user-select: none;
}

.highlight-bar {
  border: 3px solid black !important;
}

.print-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  /* Match this width to your sidebar/corner width */
  width: 250px; 
  height: 80px;
  background: #f8f9fa;
  border-top: 2px solid #ccc;
  border-right: 1px solid #ccc;
  z-index: 9999; /* Ensure it's above everything */
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.footer-content {
  display: flex;
  gap: 12px;
}

.footer-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #22c55e; /* green-500 */
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  transition: transform 0.1s;
}

.footer-btn:active {
  transform: scale(0.95);
}

.footer-btn.secondary {
  background: #64748b; /* slate-500 */
}


/* Positioning */
.selection-rectangle .resize-handle.nw { top: -24px; left: -12px; cursor: nwse-resize; }
.selection-rectangle .resize-handle.ne { top: -24px; right: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.sw { top: 100%;  left: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.se { top: 100%;  right: -12px; cursor: nwse-resize; }

.selection-rectangle .resize-handle.n {
  left: 50%;
  transform: translate(-50%, 0);
}

.selection-rectangle .resize-handle.n  { top: -24px; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.s  { top: 100%; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.e  { right: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }
.selection-rectangle .resize-handle.w  { left: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }



.undo-btn-enter-active, .undo-btn-leave-active { transition: opacity 0.2s, transform 0.2s; }
.undo-btn-enter-from, .undo-btn-leave-to { opacity: 0; transform: scale(0.7); }
</style>
